import {Action} from 'redux'
import {actionTypes} from './constants'

export interface ActionWithPayload<T> extends Action {
  payload?: T
}

const initialTutoriaState: ITutoriaState = {
  data: {
    tutorial: [],
    meta: {},
  },
  deleteSuccess: false,
  loading: false,
  success: false,
}

export interface ITutoriaState {
  data?: {
    tutorial?: []
    meta?: {[key: string]: number}
  }
  activateSuccess?: boolean
  deactivateSuccess?: boolean
  singleActivateSuccess?: boolean
  singleDeactivateSuccess?: boolean
  deleteSuccess?: boolean
  loading?: boolean
  success?: boolean
}

export const reducer = (
  state: ITutoriaState = initialTutoriaState,
  action: ActionWithPayload<ITutoriaState>
) => {
  switch (action.type) {
    case actionTypes.GET_ALL_TUTORIAL_START: {
      return {...state, loading: true}
    }

    case actionTypes.GET_ALL_TUTORIAL_SUCCESS: {
      return {...state, data: action.payload, loading: false}
    }

    case actionTypes.GET_ALL_TUTORIAL_FINISH: {
      const error = action.payload
      return {...state, error, loading: false}
    }
    case actionTypes.GET_TUTORIAL_START: {
      return {...state, loading: true}
    }

    case actionTypes.GET_TUTORIAL_SUCCESS: {
      return {...state, data: action.payload, loading: false}
    }

    case actionTypes.GET_TUTORIAL_FINISH: {
      const error = action.payload
      return {...state, error, loading: false}
    }

    case actionTypes.ADD_TUTORIAL_START: {
      return {...state, loading: true}
    }

    case actionTypes.ADD_TUTORIAL_SUCCESS: {
      return {
        ...state,
        data: action?.payload,
        success: true,
        loading: false,
      }
    }

    case actionTypes.ADD_TUTORIAL_FINISH: {
      const error = action.payload
      return {...state, error, loading: false}
    }

    case actionTypes.ADD_TUTORIAL_RESET: {
      return {
        ...state,
        data: [],
        success: false,
      }
    }

    case actionTypes.UPDATE_TUTORIAL_START: {
      return {...state, loading: true}
    }

    case actionTypes.UPDATE_TUTORIAL_SUCCESS: {
      return {
        ...state,
        data: action?.payload,
        success: true,
        loading: false,
      }
    }

    case actionTypes.UPDATE_TUTORIAL_FINISH: {
      const error = action.payload
      return {...state, error, loading: false}
    }

    case actionTypes.DELETE_TUTORIAL_START: {
      return {...state, loading: true}
    }

    case actionTypes.DELETE_TUTORIAL_SUCCESS: {
      return {
        ...state,
        deleteSuccess: true,
        loading: false,
      }
    }

    case actionTypes.DELETE_TUTORIAL_FINISH: {
      return {
        ...state,
        loading: false,
        deleteSuccess: false,
      }
    }

    case actionTypes.SINGLE_ACTIVATE_TUTORIAL_REQUEST: {
      return {...state, loading: true}
    }

    case actionTypes.SINGLE_ACTIVATE_TUTORIAL_SUCCESS: {
      return {...state, activateSuccess: true, loading: false}
    }
    case actionTypes.SINGLE_ACTIVATE_TUTORIAL_FINISH: {
      return {...state, activateSuccess: false, loading: false}
    }

    case actionTypes.SINGLE_DEACTIVATE_TUTORIAL_REQUEST: {
      return {...state, loading: true}
    }

    case actionTypes.SINGLE_DEACTIVATE_TUTORIAL_SUCCESS: {
      return {...state, deactivateSuccess: true, loading: false}
    }

    case actionTypes.SINGLE_DEACTIVATE_TUTORIAL_FINISH: {
      return {...state, deactivateSuccess: false, loading: false}
    }

    case actionTypes.SORT_TUTORIAL_START: {
      return {...state, loading: true}
    }

    case actionTypes.SORT_TUTORIAL_SUCCESS: {
      return {
        ...state,
        sortTutorialData: action?.payload,
        success: true,
        loading: false,
      }
    }

    case actionTypes.SORT_TUTORIAL_FINISH: {
      return {
        ...state,
        loading: false,
        success: false,
      }
    }

    case actionTypes.SORT_TUTORIAL_RESET: {
      return {
        ...state,
        loading: false,
        success: false,
        sortTutorialData: [],
      }
    }

    default:
      return state
  }
}
